exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.__object-form-item > legend {\n  cursor: pointer;\n}\n.__object-form-item .h-layout .row {\n  margin-left: 0;\n  margin-right: 0;\n}\n.__object-form-item .h-layout.form-row, .__object-form-item .h-layout .form-row {\n  padding: 0;\n  margin: 0;\n}\n.__object-form-item .h-layout.form-row > [class*=col-], .__object-form-item .h-layout .form-row > [class*=col-] {\n    padding-left: 5px;\n    padding-right: 5px;\n}\n.__object-form-item .h-layout [class*=col-] {\n  padding-left: 0;\n  padding-right: 0;\n}\n.__object-form-item .h-layout .col-form-label {\n  padding-right: 5px !important;\n  text-align: right;\n}\n", ""]);

// exports
